module.exports = __webpack_public_path__ + "img/career-lab.7fce5a54.svg";